import { throwIf } from "./throwErrorF/throwIfF.mts";
export const getIsValidSessId = ({ sessId }) => {
    if (sessId.length < 26)
        return false;
    return true;
};
export const guardValidSessId = ({ sessId }) => {
    throwIf(() => !getIsValidSessId({ sessId }), { sessId });
};
